import { ActionReducerMapBuilder, Draft, PayloadAction } from '@reduxjs/toolkit'
import { DataList, saveErrorInState, dismissError as commonDismissError } from '../common'
import type { UserState } from './types'
import type { fetchUsers, modifyUsers, modifyUser } from './userAPI'

export const selectIdReducer = (state: Draft<UserState>, action: PayloadAction<number>) => {
  state.selectedIds = Array.from(new Set(state.selectedIds).add(action.payload))
}

export const unselectIdReducer = (state: Draft<UserState>, action: PayloadAction<number>) => {
  const set = new Set(state.selectedIds)
  set.delete(action.payload)
  state.selectedIds = Array.from(set)
}

export const openModalReducer = (state: Draft<UserState>, action: PayloadAction<string | null>) => {
  state.openedModal = action.payload
}

export const closeModalReducer = (state: Draft<UserState>) => {
  state.openedModal = null
}

export const setSearchConditionReducer = (
  state: Draft<UserState>,
  action: PayloadAction<{ name: string; value: unknown }>
) => {
  const { name, value } = action.payload
  state.searchCondition[name] = value
}

export const buildExtraReducers = (
  builder: ActionReducerMapBuilder<UserState>,
  thunks: { fetchUsers: typeof fetchUsers; modifyUsers: typeof modifyUsers; modifyUser: typeof modifyUser }
) =>
  builder
    .addCase(thunks.fetchUsers.pending, DataList.fetchPending)
    .addCase(thunks.fetchUsers.fulfilled, DataList.fetchFulfilled)
    .addCase(thunks.fetchUsers.rejected, saveErrorInState(DataList.fetchRejected))
    .addCase(thunks.modifyUsers.pending, (state) => {
      state.fetching = true
    })
    .addCase(thunks.modifyUsers.fulfilled, (state) => {
      state.fetching = false
      state.selectedIds = []
    })
    .addCase(
      thunks.modifyUsers.rejected,
      saveErrorInState((state) => {
        state.fetching = false
      })
    )
    .addCase(thunks.modifyUser.pending, (state) => {
      state.fetching = true
    })
    .addCase(thunks.modifyUser.fulfilled, (state) => {
      state.fetching = false
    })
    .addCase(
      thunks.modifyUser.rejected,
      saveErrorInState((state) => {
        state.fetching = false
      })
    )

export { commonDismissError as dismissErrorReducer }
